import '~/assets/scss/bpif.scss'

import PageProduct from '~/js/modules/page-product';
import getSwiperSlider from '~/js/modules/slider';
import '~/js/modules/product/linked-funds'
import '~/js/modules/product/funds-year-replace'
import '~/js/modules/product/premium-discount'
import '~/js/modules/product/buy-online-links'
import '~/js/modules/tabs';
import SwitchStock from '~/js/modules/switch-stock';

new PageProduct();
window.addEventListener(`DOMContentLoaded`, () => {

  const productsSlider = document.querySelector(`.products__slider`);
  const productsSliderMobile = document.querySelector(`.products__slider-mobile`);
  let productsSwiper;
  let productsSwiperMobile;

  const productsSwiperParams = {
    slidesPerView: `auto`,
    loop: false,
    autoplay: false,
    pagination: false,
  };

  if (productsSlider) {
    productsSwiper = getSwiperSlider(productsSlider, productsSwiperParams);
  }

  if (productsSliderMobile) {
    productsSwiperMobile = getSwiperSlider(productsSliderMobile, productsSwiperParams);
  }

  const stock = document.querySelectorAll(`.js-stocks-container`);

  if (stock) {
    new SwitchStock({ container: 'stocksA', mode: 'slider' });
  }

  const isinCopyBtns = document.querySelectorAll(`.js-isin-copy`)
  if (isinCopyBtns) {
    isinCopyBtns.forEach((x) => {
      x.addEventListener('click', function () {
        let text = x.innerHTML;
        let copyhelper = document.createElement("input");
        document.body.appendChild(copyhelper);
        copyhelper.value = text;
        copyhelper.select();
        document.execCommand("copy");
        document.body.removeChild(copyhelper);
      })
    })
  }
})
